import { render, staticRenderFns } from "./AuthoritiesList.vue?vue&type=template&id=b314c288&scoped=true&"
import script from "./AuthoritiesList.vue?vue&type=script&lang=js&"
export * from "./AuthoritiesList.vue?vue&type=script&lang=js&"
import style0 from "./AuthoritiesList.vue?vue&type=style&index=0&id=b314c288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b314c288",
  null
  
)

export default component.exports